import { DOCUMENTS_NEW_ACTIONS } from "constants/actions";

export function fetchNewDocumentsList(page) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FETCH_NEW_DOCUMENTS_LIST,
        payload: {
            page
        }
    };
}
export function fetchedNewDocumentsList(data) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FETCHED_NEW_DOCUMENTS_LIST,
        payload: {
            data // will be created in a map
        }
    };
}
export function failedFetchNewDocumentsList(error) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FAILED_FETCH_NEW_DOCUMENTS_LIST,
        error
    };
}

export function fetchNewDocumentsCategoryList() {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FETCH_NEW_DOCUMENTS_CATEGORY_LIST
    };
}
export function fetchedNewDocumentsCategoryList(data) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FETCHED_NEW_DOCUMENTS_CATEGORY_LIST,
        payload: {
            data // will be created in a map
        }
    };
}
export function failedFetchNewDocumentsCategoryList(error) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FAILED_FETCH_NEW_DOCUMENTS_CATEGORY_LIST,
        error
    };
}

export function fetchNewDocumentsChecklist(page) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FETCH_DOCUMENTS_CHECKLIST,
        payload: {
            page
        }
    };
}
export function fetchedNewDocumentsChecklist(checklist) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FETCHED_DOCUMENTS_CHECKLIST,
        payload: {
            checklist // will be created in a map
        }
    };
}
export function failedFetchNewDocumentsChecklist(error) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FAILED_FETCH_DOCUMENTS_CHECKLIST,
        error
    };
}

export function fetchSingleChecklist(checklist_id) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FETCH_SINGLE_CHECKLIST,
        payload: {
            checklist_id
        }
    };
}
export function fetchedSingleChecklist(checklist_id, data) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FETCHED_SINGLE_CHECKLIST,
        payload: {
            checklist_id,
            data // will be created in a map
        }
    };
}
export function failedFetchSingleChecklist(error) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FAILED_FETCH_SINGLE_CHECKLIST,
        error
    };
}

export function updateChecklist(checklist_id, data) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.UPDATE_NEW_DOCUMENTS_CHECKLIST,
        payload: {
            checklist_id,
            data
        }
    };
}
export function updatedChecklist(checklist_id, data) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.UPDATED_NEW_DOCUMENTS_CHECKLIST,
        payload: {
            checklist_id,
            data // will be created in a map
        }
    };
}
export function failedUpdateChecklist(error) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FAILED_UPDATE_NEW_DOCUMENTS_CHECKLIST,
        error
    };
}

export function createChecklist(data) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.CREATE_NEW_DOCUMENTS_CHECKLIST,
        payload: {
            data
        }
    };
}
export function createdChecklist(data) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.CREATED_NEW_DOCUMENTS_CHECKLIST,
        payload: {
            data // will be created in a map
        }
    };
}
export function failedCreateChecklist(error) {
    return {
        type: DOCUMENTS_NEW_ACTIONS.FAILED_CREATE_NEW_DOCUMENTS_CHECKLIST,
        error
    };
}
